import styled, { css } from "styled-components";
import { isMobile as isMobileDevice } from "react-device-detect";

export const Title = styled.div`
  ${({ theme }) => css`
    width: fit-content;
    margin-top: 40px;
    margin-bottom: 24px;
    margin-left: ${theme.old.sizes.sidesMargin.large};
    
    ${theme.old.breakpoints.isTab} {
      margin-left: ${({ theme }) => theme.old.sizes.sidesMargin.small};
    }

    ${theme.old.breakpoints.isMobile} {
      margin-top: 32px;
      margin-bottom: 16px;
    }
  `}
`

export const CarouselContainer = styled.div`
  ${({ theme }) => {

    if (isMobileDevice) return css`
      ${theme.old.breakpoints.isTabLand} {
        margin-left: ${({ theme }) => theme.old.sizes.sidesMargin.large};
        margin-right: 0;
      }

      ${theme.old.breakpoints.isTab} {
        margin-left: ${({ theme }) => theme.old.sizes.sidesMargin.small};
        margin-right: 0;
      }
    `
  
    return css`
      margin: 0 ${theme.old.sizes.sidesMargin.large};
  
      ${theme.old.breakpoints.isTab} {
        margin-left: ${({ theme }) => theme.old.sizes.sidesMargin.small};
        margin-right: 0;
      }
    `
  
  }}
  /* margin: 0 ${({ theme }) => theme.old.sizes.sidesMargin.large};

  ${({ theme }) => theme.old.breakpoints.isTab} {
    margin-left: ${({ theme }) => theme.old.sizes.sidesMargin.small};
    margin-right: 0;
  } */
`